import { render, staticRenderFns } from "./LandingPageEdit.vue?vue&type=template&id=1b83a631&"
import script from "./LandingPageEdit.vue?vue&type=script&lang=js&"
export * from "./LandingPageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports